export default __webpack_public_path__ + "static/media/clipboard.fcecab76.svg";